// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"error_errorPage__yjBsw","icon":"error_icon__gnCzr","message":"error_message__2Fxua","btn":"error_btn__bF-op"};